export function formatNumber(number: string, language = 'en') {
  let [integerPart, decimalPart] = number.split('.');

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  const decimalSeparator = language === 'ru' || language === 'by' ? ',' : '.';

  return decimalPart
    ? `${integerPart}${decimalSeparator}${decimalPart}`
    : integerPart;
}
